import React from 'react';
import { browsers, operatingSystems } from 'shared/constants/matomo';
import { getDimensionRawValue } from 'shared/utils/dimensionValue';
import apple from './assets/apple.svg';
import samsungInternet from './assets/samsung-internet.svg';

import googlechrome from './assets/googlechrome.svg';
import firefoxbrowser from './assets/firefoxbrowser.svg';
import safari from './assets/safari.svg';
import microsoftedge from './assets/microsoftedge.svg';
import opera from './assets/opera.svg';
import internetexplorer from './assets/internetexplorer.svg';

import windows from './assets/windows.svg';
import android from './assets/android.svg';
import linux from './assets/linux.svg';
import ubuntu from './assets/ubuntu.svg';

import brave from './assets/brave.svg';
import duckduckgo from './assets/duckduckgo.svg';
import vivaldi from './assets/vivaldi.svg';
import chromium from './assets/chromium.svg';
import uc from './assets/uc.svg';
import silk from './assets/silk_32x32.png';
import yandex from './assets/yandex_32x32.png';
import debian from './assets/debian.svg';
import fedora from './assets/fedora.svg';
import linuxmint from './assets/linuxmint.svg';
import archlinux from './assets/archlinux.svg';
import amazon from './assets/amazon.svg';

const labels = { browser: browsers, operatingSystem: operatingSystems };
const icons = {
  operatingSystem: {
    windows,
    android,
    'android tv': android,
    'gnu/linux': linux,
    linux,
    ubuntu,
    debian,
    fedora,
    mint: linuxmint,
    'linux mint': linuxmint,
    'arch linux': archlinux,
    mac: apple,
    macos: apple,
    osx: apple,
    'os x': apple,
    'mac os x': apple,
    ios: apple,
    ipados: apple,
    'chrome os': googlechrome,
    'fire os': amazon,
  },
  browser: {
    brave,
    'duckduckgo privacy browser': duckduckgo,
    duckduckgo,
    vivaldi,
    chromium,
    'firefox focus': firefoxbrowser,
    'mobile silk': silk,
    'amazon silk': silk,
    'uc browser': uc,
    'uc browser hd': uc,
    'uc browser mini': uc,
    'uc browser turbo': uc,
    'yandex browser': yandex,
    'yandex browser corp': yandex,
    'yandex browser lite': yandex,
    chrome: googlechrome,
    'chrome mobile': googlechrome,
    'chrome mobile ios': googlechrome,
    'chrome webview': googlechrome,
    'headless chrome': googlechrome,
    firefox: firefoxbrowser,
    'firefox mobile': firefoxbrowser,
    'firefox mobile ios': firefoxbrowser,
    safari,
    'mobile safari': safari,
    'safari technology preview': safari,
    'microsoft edge': microsoftedge,
    'edge webview': microsoftedge,
    opera,
    'opera mini': opera,
    'opera mobile': opera,
    'opera gx': opera,
    'internet explorer': internetexplorer,
    'samsung browser': samsungInternet,
  },
};

export const hasTechnologyIcons = type => Object.hasOwn(icons, type);

const TechnologyIcon = ({ type, value }) => {
  const names = Object.hasOwn(labels, type) ? labels[type] : {};
  const rawValue = getDimensionRawValue(value);
  const label = Object.hasOwn(names, rawValue) ? names[rawValue] : rawValue;
  const key = String(label ?? '').trim().toLowerCase();
  const assets = hasTechnologyIcons(type) ? icons[type] : {};
  const src = Object.hasOwn(assets, key) ? assets[key] : undefined;
  return src
    ? <img src={src} alt="" aria-hidden="true" width={16} height={16} style={{ verticalAlign: 'middle', objectFit: 'contain' }} />
    : <span aria-hidden="true" style={{ display: 'inline-block', width: 16, height: 16, verticalAlign: 'middle' }} />;
};

export default TechnologyIcon;
